import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import axios from 'axios';
import htmlParser from 'react-html-parser';

import useAuth from '../../controllers/users/useAuth';
import {
    awaitDelay, dataTableLanguaje, globalSettings, languageObjGet, responseGet, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, numberSet, separatorsNumbersSet,
    statusListGet, styles, textByNumericStatus, isUndNullEmp, LoadingSection, lodash,
} from '../../helpers/settings';

import Menu from '../main/Menu';
import HtmlParser from 'react-html-parser';
import CssfxLoading from '../main/CssfxLoading';
import Swal from 'sweetalert2';
import InformativeBillboardAddEdit from '../informativeBillboard/InformativeBillboardAddEdit';
import { condominiumBoardElectionResultsGetAsync } from '../condominuimBoards/helper';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { informativeBillboardModelGet } from '../../models/informativeBillboard/informativeBillboard';
import { collectionCashModelGet } from '../../models/collections/collectionCash';

const currentMethod = 'Home';

const { app, collections: dbColle, colors, html: htmlSett, icons, labels, messages, react, timers, } = globalSettings;
const { backend, } = app;
const { html: htmlReact, firebase, sweetAlert2, } = react;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = firebase;

export default function Home({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    //#region Globals
    const auth = useAuth();
    const dtApartmentsBalanceId = 'dtApartmentsBalance'
    const dtCollectionCachesId = 'dtCollectionCaches';
    const dtSuppliersCurrenBalanceId = 'dtSuppliersCurrenBalanceId';
    let nothingLocal = {}; // eslint-disable-line no-unused-vars
    let result;
    let dataObj = {};
    let headers = {};
    //const [showData, setShowData] = useState(false);
    //const [showLoading, setShowLoading] = useState(false);
    //const [showDataByBuilding, setShowDataByBuilding] = useState(true);
    //const [showLoadingByBuilding, setShowLoadingByBuilding] = useState(false);
    const [banks, setBanks] = useState([]);
    const [banksTake, setBanksTake] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const neutralValue = 0.00;
    // const [buildings, setBuildings] = useState([]);
    // const [buildingsQuantity, setBuildingsQuantity] = useState(0);
    // const [buildingBalance, setBuildingBalance] = useState(numberSet(neutralValue, 'd').result);
    // const [buildingBalanceFormat, setBuildingBalanceFormat] = useState('');
    const [apartments, setApartments] = useState([]);
    const [apartmentsQuantity, setApartmentsQuantity] = useState(0);
    const [apartmentBalance, setApartmentBalance] = useState(numberSet({ number: neutralValue, type: 'd', languageId: languageObj?.id, subMethod: currentMethod })?.result);
    const [apartmentsBalance, setApartmentsBalance] = useState([]);
    const [apartmentBalanceFormat, setApartmentBalanceFormat] = useState(separatorsNumbersSet({ number: neutralValue, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
    const [suppliersCurrentBalance, setSuppliersCurrentBalance] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [documentsTake, setDocumentsTake] = useState([]);
    const [collectionCaches, setCollectionCashes] = useState([]);
    const [collectionCachesTake, setCollectionCashesTake] = useState([]);
    const controls = {
        buttons: {
            // home: {
            //     className: 'btn btn-sm btn-outline-success',
            //     id: 'btnHome',
            // },
            condominiumBoardElectionPreviousResults: {
                //className: 'btn btn-sm btn-outline-primary mx-1',
                //className: 'btn btn-sm btn-outline-primary float-right',
                className: 'btn btn-outline-secondary btn-sm mx-1',
                id: 'btnCondominiumBoardElectionPreviousResults',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        icons: {
            condominiumBoardElectionPreviousResults: {
                id: 'iconCondominiumBoardElectionPreviousResults',
                className: icons?.chartBar,
            },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        selects: {
            buildings: {
                id: 'selBuildings',
                className: 'custom-select',
            }
        },
        spinners: {
            condominiumBoardElectionPreviousResults: {
                id: 'spCondominiumBoardElectionPreviousResults',
                className: '',
            }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion Globals

    //#region buildings
    const [buildings, setBuildings] = useState([]);
    const [buildingDescription, setBuildingDescription] = useState('');
    const [buildingsQuantity, setBuildingsQuantity] = useState(0);
    const [buildingBalance, setBuildingBalance] = useState(numberSet({ number: neutralValue, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result);
    const [buildingBalanceFormat, setBuildingBalanceFormat] = useState(separatorsNumbersSet({ number: neutralValue, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
    //#endregion buildings

    //#region informative billboard
    const [informativeBillboards, setInformativeBillboards] = useState([]);
    const [informativeBillboard, setInformativeBillboard] = useState({});
    const [informativeBillboardShow, setInformativeBillboardShow] = useState(false);
    //#endregion informative billboard

    //#region condominium board (elections)
    const labelStatusId = 'labelStatus';
    const chkApplicants01Id = 'chkApplicants01';
    //const chkApplicants02Id = 'chkApplicants02';
    //const chkApplicantsName = 'chkApplicants';
    const statusList = statusListGet({ type: 'I', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const btnApplicantSelectedId = 'btnApplicantSelected';
    const dtCondominiumBoardElectionsId = 'dtCondominiumBoardElections';
    const [applicantsHidden, setApplicantsHidden] = useState(true);
    const [showApplicantsLoading, setShowApplicantsLoading] = useState(false);
    const [condominiumBoardElection, setCondominiumBoardElection] = useState({});
    const [btnSaveElectionShowSpinner, setBtnSaveElectionShowSpinner] = useState(false);
    const [condominiumBoardElectionDetails, setCondominiumBoardElectionDetails] = useState([]);
    const [condominiumBoardElectionStatus, setCondominiumBoardElectionStatus] = useState({ id: 0, description: '', });
    //const [executedVote, setExecutedVote] = useState(false);
    const [executedVote, setExecutedVote] = useState({ executed: false, date: new Date()?.toISOString(), });
    const [applicantSeleted, setApplicantSeleted] = useState({ id: '', description: '', hierarchy: 0, rowIndex: 0, e: {} });
    //#endregion condominium board (elections)

    //#region Loadings
    const [buildingsQuantityShow, setBuildingsQuantityShow] = useState(true);
    const [apartmentsQuantityShow, setApartmentsQuantityShow] = useState(true);
    const [apartmentBalanceShow, setApartmentBalanceShow] = useState(true);
    const [buildingBalanceShow, setBuildingBalanceShow] = useState(true);

    const [informativeBillboardLoadingShow, setInformativeBillboardLoadingShow] = useState(true);
    const [condominiumBoardElectionShow, setCondominiumBoardElectionShow] = useState(true);

    const [apartmentsBalanceShow, setApartmentsBalanceShow] = useState(true);
    const [documentsShow, setDocumentsShow] = useState(true);

    const [suppliersBalanceShow, setSuppliersBalanceShow] = useState(true);
    const [collectionCashesBalanceShow, setCollectionCashesBalanceShow] = useState(true);

    const [banksBalanceShow, setBanksBalanceShow] = useState(true);
    //#endregion Loadings
    //#endregion variables

    //#region methods
    //#region buildings
    const buildingDataGetAsync = async ({ e = {}, subMethod = '',
    }) => {
        const currentMethod = 'buildingDataGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e.preventDefault();
            }

            //#region variables
            let voteExecutedLocal = false;
            let collectionCachesLocal = [];
            let apartmentsBalanceLocal = [];
            let buildingIdLocal = e?.target?.value;
            let suppliersCurrentBalanceLocal = [];
            let condominiumBoardElectionDetailsLocal = [];
            //#endregion variables

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //setShowDataByBuilding(false);
                //setShowLoadingByBuilding(true);
                await controlsLoadingSetAsync({
                    _buildingQuantityShow: true,
                    _apartmentQuantityShow: true,
                    _apartmentBalanceShow: true,
                    _buildingBalanceShow: true,
                    _informativeBillboardLoadingShow: true,
                    _condominiumBoardElectionShow: true,
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });

                //#region initialize
                //setBuildings([]);
                setApartments([]);
                setApartmentsQuantity(0);
                setApplicantsHidden(true);
                setBuildingBalanceFormat(separatorsNumbersSet({ number: neutralValue, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
                setApartmentBalanceFormat(separatorsNumbersSet({ number: neutralValue, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
                setBuildingDescription(buildings?.filter(({ id }) => id === buildingIdLocal)?.[0]?.description);

                setInformativeBillboards([]);
                setCondominiumBoardElection({});
                setCondominiumBoardElectionDetails([]);
                setDocumentsTake([]);
                setBanksTake([]);
                //#endregion initialize

                //#region dataTable set (clear)
                response = dataTablesClear({
                    dtApartmentsBalance: true,
                    dtSuppliersBalance: true,
                    dtCollectionCashes: true,
                    dtInformativeBillboard: true,
                    dtCondominiumBoardElections: true,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowDataByBuilding(false);
                    //setShowLoadingByBuilding(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (clear)

                //#region data get (home)
                headers = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    }
                };
                dataObj = {
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlHome}/`,
                    conditionals: [],
                    ordersBy: [],
                    buildingId: buildingIdLocal,
                    //userId: auth?.user?.uid,
                    method: backend?.methods?.home?.dataByBuildingId,
                    languageId: languageObj?.id,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headers,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    //setShowDataByBuilding(false);
                    //setShowLoadingByBuilding(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion data get (home)

                //#region data set
                response = dataSet({
                    data: response?.result,
                    buildindsDataSet: false,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    //setShowDataByBuilding(false);
                    //setShowLoadingByBuilding(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                voteExecutedLocal = response?.result?.voteExecuted;
                collectionCachesLocal = response?.result?.collectionCaches;
                apartmentsBalanceLocal = response?.result?.apartmentsBalance;
                suppliersCurrentBalanceLocal = response?.result?.suppliersCurrentBalance;
                condominiumBoardElectionDetailsLocal = response?.result?.condominiumBoardElectionDetails;
                //#endregion data set

                //setShowLoadingByBuilding(false);
                //setShowDataByBuilding(true);

                //#region dataTable set (set)
                response = dataTablesSet({
                    dtInformativeBillboard: false,
                    dtCondominiumBoardElections: true,
                    apartmentsBalance: false,
                    suppliersCurrenBalance: false,
                    collectionCaches: false,
                    queryCodeSet: true,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    //setShowDataByBuilding(false);
                    //setShowLoadingByBuilding(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (set)

                //#region old code
                // //#region dataTable set (clear)
                // response = dataTablesClear({
                //     dtApartmentsBalance: false,
                //     dtSuppliersBalance: false,
                //     dtCollectionCashes: false,
                //     dtInformativeBillboard: false,
                //     dtCondominiumBoardElections: true,
                //     subMethod: currentMethod
                // });
                // if (!response?.isSuccess || response?.isWarning) {
                //     //setShowDataByBuilding(false);
                //     //setShowLoadingByBuilding(false);
                //     await controlsLoadingSetAsync({});
                //     await sendMessageCloseCurrentWindowAsync({
                //         msgType: response?.msgType,
                //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //         closeWindow: false,
                //         urlGoTo: response?.urlGoTo,
                //         auth: auth,
                //         isLogout: false,
                //         languageId: languageObj?.id,
                //         subMethod: currentMethod,
                //     });
                //     return;
                // }
                // //#endregion dataTable set (clear)
                //#endregion old code

                //#region dataTable set (data)
                response = dataTablesDataSet({
                    dataApartmentsBalance: apartmentsBalanceLocal,
                    dataSuppliersBalance: suppliersCurrentBalanceLocal,
                    dataCollectionCashes: collectionCachesLocal,
                    dtCondominiumBoardElectionDetails: condominiumBoardElectionDetailsLocal,
                    executedVote: voteExecutedLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    //setShowDataByBuilding(false);
                    //setShowLoadingByBuilding(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (data)

                //#region Loading section
                await controlsLoadingSetAsync({
                    _buildingQuantityShow: false,
                    _apartmentQuantityShow: false,
                    _apartmentBalanceShow: false,
                    _buildingBalanceShow: false,
                    _informativeBillboardLoadingShow: true,
                    _condominiumBoardElectionShow: true,
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });

                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({});
                //#endregion Loading section
            }
        } catch (ex) {
            //setShowDataByBuilding(false);
            //setShowLoadingByBuilding(false);
            await controlsLoadingSetAsync({});
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion buildings

    //#region condominium board election
    const applicantsSelectedGet = ({
        e = {},
        id = '',
        description = '',
        hierarchy = 0,
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'applicantsSelectedGet';
        let response = responseGet();
        try {
            if (condominiumBoardElectionStatus?.id === 1) {
                setApplicantSeleted({ id, description, hierarchy, rowIndex, e });
                $(`#${btnApplicantSelectedId}`)?.trigger('click');
            }
            setApplicantSeleted({ id, description, hierarchy, rowIndex, e });
            $(`#${btnApplicantSelectedId}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const applicantsSelectedPost = ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'applicantsSelectedPost';
        let response = responseGet();
        try {
            e?.preventDefault();

            if (condominiumBoardElectionStatus?.id === 1) {
                //#region data set
                let newArray = condominiumBoardElectionDetails?.map((detail) => {
                    if (detail?.hierarchy === applicantSeleted?.hierarchy && detail?.id === applicantSeleted?.id) {
                        return { ...detail, votes: [{ userId: auth?.user?.uid, date: new Date()?.toISOString(), selected: true, }] };
                    } else if (detail?.hierarchy === applicantSeleted?.hierarchy && detail?.id !== applicantSeleted?.id) {
                        //return { ...detail, votes: [] };
                        return { ...detail, votes: [{ userId: auth?.user?.uid, date: new Date()?.toISOString(), selected: false, }] };
                    } else {
                        return detail;
                    }
                    //#region old code
                    //return detail?.id === applicantSeleted.id ? { ...detail, votes: [{ userId: auth?.user?.uid, date: new Date()?.toISOString(), }] } : detail;
                    //#endregion old code
                });

                setCondominiumBoardElectionDetails(newArray);
                //setApplicantSeleted({ id: '', description: '', hierarchy: 0, rowIndex: 0, e: {} });
                //#endregion data set

                //#region Errase selection previus
                const dt = $(`#${dtCondominiumBoardElectionsId}`)?.DataTable();
                const dtRows = dt?.rows()?.data()?.length;

                if (!isUndNullEmp({ data: dtRows, subMethod: currentMethod, })?.result && dtRows > 0) {
                    dt?.rows()?.data()?.map((detail, rowIndex) => {// eslint-disable-line array-callback-return
                        if (detail?.[5] === applicantSeleted?.hierarchy) {
                            if (rowIndex !== applicantSeleted?.rowIndex) {
                                const newRowData = [
                                    detail?.[0],
                                    detail?.[1],
                                    detail?.[2],
                                    detail?.[3],
                                    detail?.[4],
                                    detail?.[5],
                                    checkBoxApplicantsGet({
                                        condominiumBoardRoleDescription: detail?.[4],
                                        hierarchy: detail?.[5],
                                        id: detail?.[0],
                                        selected: false,
                                        executedVote: false,
                                        subMethod: currentMethod,
                                    }).result,
                                ];
                                dt?.row(rowIndex)?.data(newRowData);
                            } else {
                                //console.log(detail);
                            }
                        }
                    });
                }

                setApplicantSeleted({ id: '', description: '', hierarchy: 0, rowIndex: 0, e: {} });
                //#endregion Errase selection previus
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const applicantsSelectEraser = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'applicantsSelectEraser';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e.preventDefault();
            }

            //#region old code
            // //#region show modal initialize
            // const swalProperty = {
            //     icon: sweetAlert2?.icons?.warning,
            //     title: messages?.doYouWantToInitializeTheVote?.[languageObj?.id],
            //     html: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            //     timer: null,
            //     confirmButtonColor: colors?.warningColorExp,
            //     confirmButtonText: labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: colors?.successColorExp,
            //     cancelButtonText: labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal?.fire(swalProperty);
            // //#endregion show modal initialize

            // //#region method
            // if (isConfirmed && condominiumBoardElectionStatus.id === 1 && !executedVote?.executed) {
            //     const condominiumBoardElectionStatusLocal = condominiumBoardElectionStatus;
            //     setCondominiumBoardElectionStatus({ ...condominiumBoardElectionStatusLocal, id: 0, });

            //     setShowApplicantsLoading(true);

            //     //#region delay
            //     await awaitDelay({ delayTimer: timers?.oneSecond });
            //     //#endregion delay

            //     //#region clear data votes
            //     let condominiumBoardElectionDetailsLocal = condominiumBoardElectionDetails?.map((detail) => {
            //         // 0 - Vote null
            //         // 1 - Vote partial
            //         // 2 - Vote complete
            //         return { ...detail, votes: [{ userId: auth?.user?.uid, date: new Date()?.toISOString(), selected: false, type: 0, }] };
            //     });

            //     setCondominiumBoardElectionDetails(condominiumBoardElectionDetailsLocal);
            //     //#endregion clear data votes

            //     setShowApplicantsLoading(false);

            //     //#region dataTable set (set)
            //     response = dataTablesSet({
            //         dtInformativeBillboard: false,
            //         dtCondominiumBoardElections: true,
            //         apartmentsBalance: false,
            //         suppliersCurrenBalance: false,
            //         collectionCaches: false,
            //         queryCodeSet: true,
            //         subMethod: currentMethod,
            //     });

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync({
            //             msgType: response?.msgType,
            //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //             closeWindow: false,
            //             urlGoTo: response?.urlGoTo,
            //             auth: auth,
            //             isLogout: false,
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         });
            //         return response;
            //     }
            //     //#endregion dataTable set (set)

            //     //#region clear data table
            //     response = dataTablesClear({
            //         dtApartmentsBalance: false,
            //         dtSuppliersBalance: false,
            //         dtCollectionCashes: false,
            //         dtInformativeBillboard: false,
            //         dtCondominiumBoardElections: true,
            //         subMethod: currentMethod
            //     });

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync({
            //             msgType: response?.msgType,
            //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //             closeWindow: false,
            //             urlGoTo: response?.urlGoTo,
            //             auth: auth,
            //             isLogout: false,
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         });
            //         return response;
            //     }
            //     //#endregion clear data table

            //     //#region dataTable set (data)
            //     response = dataTablesDataSet({
            //         dataApartmentsBalance: [],
            //         dataSuppliersBalance: [],
            //         dataCollectionCashes: [],
            //         dtCondominiumBoardElectionDetails: condominiumBoardElectionDetailsLocal,
            //         executedVote: false,
            //         subMethod: currentMethod,
            //     });

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync({
            //             msgType: response?.msgType,
            //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //             closeWindow: false,
            //             urlGoTo: response?.urlGoTo,
            //             auth: auth,
            //             isLogout: false,
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         });
            //         return response;
            //     }
            //     //#endregion dataTable set (data)

            //     setCondominiumBoardElectionStatus(condominiumBoardElectionStatusLocal);
            // }
            // //#endregion method
            //#endregion old code

            //#region show message
            let msgTextObj = {
                one: `${messages?.doYouWantToInitializeTheVote?.[languageObj?.id]}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                //title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                //title: messages?.AreYouSureAboutThis?.[languageObj?.id],
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            //title: `${messages?.processing?.[languageObj?.id]}...`,
                            //html: `${msgTextObj?.one}`,
                            title: `${labels?.information?.[languageObj?.id]}`,
                            html: `${messages?.processing?.[languageObj?.id]}...`,
                            showConfirmButton: false,
                        });

                        //#region delete countr
                        if (condominiumBoardElectionStatus.id === 1 && !executedVote?.executed) {
                            const condominiumBoardElectionStatusLocal = condominiumBoardElectionStatus;
                            setCondominiumBoardElectionStatus({ ...condominiumBoardElectionStatusLocal, id: 0, });

                            setShowApplicantsLoading(true);

                            //#region clear data votes
                            let condominiumBoardElectionDetailsLocal = condominiumBoardElectionDetails?.map((detail) => {
                                // 0 - Vote null
                                // 1 - Vote partial
                                // 2 - Vote complete
                                return { ...detail, votes: [{ userId: auth?.user?.uid, date: new Date()?.toISOString(), selected: false, type: 0, }] };
                            });

                            setCondominiumBoardElectionDetails(condominiumBoardElectionDetailsLocal);
                            //#endregion clear data votes

                            //#region delay
                            await awaitDelay({ delayTimer: timers?.oneSecond });
                            //#endregion delay

                            setShowApplicantsLoading(false);

                            //#region dataTable set (set)
                            response = dataTablesSet({
                                dtInformativeBillboard: false,
                                dtCondominiumBoardElections: true,
                                apartmentsBalance: false,
                                suppliersCurrenBalance: false,
                                collectionCaches: false,
                                queryCodeSet: true,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return response;
                            }
                            //#endregion dataTable set (set)

                            //#region clear data table
                            response = dataTablesClear({
                                dtApartmentsBalance: false,
                                dtSuppliersBalance: false,
                                dtCollectionCashes: false,
                                dtInformativeBillboard: false,
                                dtCondominiumBoardElections: true,
                                subMethod: currentMethod
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return response;
                            }
                            //#endregion clear data table

                            //#region dataTable set (data)
                            response = dataTablesDataSet({
                                dataApartmentsBalance: [],
                                dataSuppliersBalance: [],
                                dataCollectionCashes: [],
                                dtCondominiumBoardElectionDetails: condominiumBoardElectionDetailsLocal,
                                executedVote: false,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return response;
                            }
                            //#endregion dataTable set (data)

                            setCondominiumBoardElectionStatus(condominiumBoardElectionStatusLocal);
                        }
                        //#endregion delete country

                        //#region old code
                        // await sendMessageCloseCurrentWindowAsync({
                        //     msgType: 0,
                        //     msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        //     closeWindow: false,
                        //     urlGoTo: response?.urlGoTo,
                        //     auth: auth,
                        //     isLogout: false,
                        //     languageId: languageObj?.id,
                        //     subMethod: currentMethod,
                        // });
                        //#endregion old code
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message   
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const condominiumBoardElectionVoteGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'condominiumBoardElectionVoteGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let msgText = '';
            let voteIsNull = true;
            let swalProperty = {};
            let voteHierarchyLocal = [];
            let voteHierarchyIsSelectedLocal = false;
            let voteHierarchiesNotSelectedLocal = '';
            //#endregion variables

            if (condominiumBoardElectionStatus?.id === 1 && !executedVote?.executed) {
                //#region check if vote null
                condominiumBoardElectionDetails?.forEach((detail) => {
                    if (detail?.votes?.[0]?.selected === true) {
                        voteIsNull = !detail?.votes?.[0]?.selected;
                        return;
                    }
                });

                msgText = `${messages?.didNotSelectAnyApplicant?.[languageObj?.id]}<br/>`;
                msgText += `${messages?.yourVoteWillBeRegisteredAsNull?.[languageObj?.id]}<br/>`;
                msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}<br/>`;

                if (voteIsNull) {
                    swalProperty = {
                        icon: sweetAlert2?.icons?.warning,
                        title: messages?.invalidVote?.[languageObj?.id],
                        html: msgText,
                        timer: null,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                    };

                    const { isConfirmed, } = await Swal?.fire(swalProperty);
                    if (isConfirmed) {
                        response = await condominiumBoardElectionVotePostAsync({ voteType: 0, subMethod: currentMethod, });
                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return response;
                        }
                        await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, '', null, false);
                    }
                }
                //#endregion check if vote null

                //#region check if exist herarchy not selected
                if (!voteIsNull) {
                    voteHierarchyLocal = lodash?.unique({
                        data: condominiumBoardElectionDetails,
                        key: dbProps?.hierarchy,
                        subMethod: currentMethod,
                    })?.result; //uniqBy(condominiumBoardElectionDetails, 'hierarchy');

                    if (!isUndNullEmp({ data: voteHierarchyLocal, subMethod: currentMethod, })?.result && voteHierarchyLocal?.length > 0) {
                        voteHierarchyLocal?.forEach((hierarchyDetail) => {
                            const applicantsByRole = condominiumBoardElectionDetails?.filter(({ hierarchy }) => hierarchy === hierarchyDetail?.hierarchy);
                            if (!isUndNullEmp({ data: applicantsByRole, subMethod: currentMethod, })?.result && applicantsByRole?.length > 0) {
                                applicantsByRole?.forEach((applicantDetail) => {
                                    if (applicantDetail?.votes?.[0]?.selected === true) {
                                        voteHierarchyIsSelectedLocal = true;
                                        return;
                                    }
                                });
                                if (voteHierarchyIsSelectedLocal) {
                                    voteHierarchyIsSelectedLocal = false;
                                    return;
                                } else {
                                    voteHierarchiesNotSelectedLocal += `<b>${hierarchyDetail?.condominiumBoardRole?.description}</b><br/>`;
                                }
                            }
                        });

                        if (!isUndNullEmp({ data: voteHierarchiesNotSelectedLocal, subMethod: currentMethod, })?.result) {
                            msgText = `${messages?.youHaveNotSelectedRoles?.[languageObj?.id]}<br/>`;
                            msgText += `${voteHierarchiesNotSelectedLocal}`;
                            msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}<br/>`;

                            swalProperty = {
                                icon: sweetAlert2?.icons?.warning,
                                title: messages?.incompleteVote?.[languageObj?.id],
                                html: msgText,
                                timer: null,
                                confirmButtonColor: colors?.warningColorExp,
                                confirmButtonText: labels?.yes?.[languageObj?.id],
                                showCancelButton: true,
                                cancelButtonColor: colors?.successColorExp,
                                cancelButtonText: labels?.no?.[languageObj?.id],
                                didOpen: () => {
                                    Swal.hideLoading();
                                },
                            };

                            const { isConfirmed, } = await Swal.fire(swalProperty);

                            if (isConfirmed) {
                                response = await condominiumBoardElectionVotePostAsync({ voteType: 1, subMethod: currentMethod, });
                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return response;
                                }
                                //await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, '', null, false);
                                sendMessageCloseCurrentWindowAsync({
                                    msgType: 0,
                                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                            }
                        } else {
                            response = await condominiumBoardElectionVotePostAsync({ voteType: 2, subMethod: currentMethod, });
                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return response;
                            }
                            //await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, '', null, false);
                            sendMessageCloseCurrentWindowAsync({
                                msgType: 0,
                                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                        }
                    }
                }
                //#endregion check if exist herarchy not selected
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const condominiumBoardElectionVotePostAsync = async ({
        voteType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'condominiumBoardElectionVotePostAsync';
        let response = responseGet();
        try {
            // 0 - Vote null
            // 1 - Vote partial
            // 2 - Vote complete

            //#region variable
            let condominiumBoardElectionStatusLocal = condominiumBoardElectionStatus;
            let executedVoteLocal = true;
            let voteExecutedDateLocal = new Date()?.toISOString();
            //#endregion variable

            if (condominiumBoardElectionStatus.id === 1) {
                //#region set vote type
                if (voteType !== 0) {
                    condominiumBoardElectionDetails?.forEach((detail) => {
                        detail.votes[0].type = voteType;
                    });
                }
                //#endregion set vote type

                setCondominiumBoardElectionStatus({ ...condominiumBoardElectionStatusLocal, id: 0, });
                setBtnSaveElectionShowSpinner(true);
                setShowApplicantsLoading(true);
                $('#back-to-top')?.[0]?.click();

                //#region update data
                headers = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    }
                };

                dataObj = {
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElectionDetails}/`,
                    conditionals: [],
                    details: condominiumBoardElectionDetails,
                    method: backend?.methods?.vote,
                    ordersBy: [],
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headers,
                );
                response = result.data;

                //#region old code
                // setBtnSaveElectionShowSpinner(false);
                // setShowApplicantsLoading(false);
                // //setExecutedVote(true);
                // setExecutedVote({ executed: true, date: new Date()?.toISOString(), });
                //#endregion old code

                setBtnSaveElectionShowSpinner(false);
                setShowApplicantsLoading(false);

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
                setExecutedVote({ executed: true, date: new Date()?.toISOString(), });

                setCondominiumBoardElection({ ...condominiumBoardElection, executedVote: executedVoteLocal, executedVoteDate: voteExecutedDateLocal, });

                //#region dataTable set (set)
                response = dataTablesSet({
                    dtInformativeBillboard: false,
                    dtCondominiumBoardElections: true,
                    apartmentsBalance: false,
                    suppliersCurrenBalance: false,
                    collectionCaches: false,
                    queryCodeSet: false,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return response;
                }
                //#endregion dataTable set (set)

                //#region clear data table
                response = dataTablesClear({
                    dtApartmentsBalance: false,
                    dtSuppliersBalance: false,
                    dtCollectionCashes: false,
                    dtInformativeBillboard: false,
                    dtCondominiumBoardElections: true,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return response;
                }
                //#endregion clear data table

                //#region dataTable set (data)
                response = dataTablesDataSet({
                    dataApartmentsBalance: [],
                    dataSuppliersBalance: [],
                    dataCollectionCashes: [],
                    dtCondominiumBoardElectionDetails: condominiumBoardElectionDetails,
                    executedVote: executedVoteLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return response;
                }
                //#endregion dataTable set (data)

                setCondominiumBoardElectionStatus(condominiumBoardElectionStatusLocal);
                //#endregion update data
            }
        } catch (ex) {
            setBtnSaveElectionShowSpinner(false);
            setShowApplicantsLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const checkBoxApplicantsGet = ({
        condominiumBoardRoleDescription = '',
        hierarchy = 0,
        id = '',
        selected = false,
        executedVote = false,
        subMethod = '',
    }) => {
        const currentMethod = 'checkBoxApplicantsGet';
        let response = responseGet();
        try {
            response.result = `<div class='custom-control custom-radio' style='cursor: ${executedVote ? "default" : "pointer"}'>`;
            //response.result += `<input class='custom-control-input custom-control-input-primary' ${selected ? 'checked' : ''} description='${condominiumBoardRoleDescription}' method='${hierarchy}' id='${id}' `;
            response.result += `    <input class='custom-control-input custom-control-input-primary' ${selected ? 'checked' : ''}  `;
            response.result += `        description='${condominiumBoardRoleDescription}' `;
            response.result += `        ${executedVote ? 'disabled' : ''} `;
            response.result += `        method='${hierarchy}' id='${id}' `;
            response.result += `        name='${condominiumBoardRoleDescription}' type='radio' style='cursor: ${executedVote ? "default" : "pointer"}'>`;
            response.result += `    <label for='${id}' class='custom-control-label' style='cursor: ${executedVote ? "default" : "pointer"}'></label>`;
            response.result += `</div>`;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const condominiumBoardElectionPreviousResultsGetAsync = async ({
        e = {},
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'condominiumBoardElectionPreviousResultsGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            response = await condominiumBoardElectionResultsGetAsync({
                id: id,
                buildingId: $(`#${controls?.selects?.buildings?.id}`)?.val(),
                isResumen: true,
                auth: auth,
                //reportName: app?.reports?.electionResultsPrint,
                reportName: app?.reports?.electionPreviousResultsPrint,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion condominium board election

    //#region informative billboard
    const informativeBillboardHtmlDataGet = ({
        informativeBillboards = [],
        subMethod = '',
    }) => {
        const currentMethod = 'informativeBillboardHtmlDataGet';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const buildingId = buildings?.[0]?.id;
            //#endregion old code
            const buildingId = $(`#${controls?.selects?.buildings?.id}`)?.val();
            informativeBillboards = informativeBillboards?.slice(0, 6); //take(informativeBillboards, 6);
            let textColor = '';
            const textColorArray = textByNumericStatus({ languageId: languageObj?.id, subMethod: currentMethod, });
            response.result = ``;
            //#endregion variables

            //#region process
            informativeBillboards?.map((detail, index) => {// eslint-disable-line array-callback-return
                textColor = textColorArray?.filter(({ id, }) => parseInt(id) === detail?.type)?.[0];
                if ((index % 2 === 0)) {
                    response.result += `<div class='row'>`;
                }
                response.result += `    <div class='col-md-6'>`;
                response.result += `        <ul class='products-list product-list-in-card pl-2 pr-2'>`;
                response.result += `            <li class='item'>`;
                response.result += `                <div class='product-img'>`;
                response.result += `                    <img src='${detail?.iconPath}' alt='${detail?.iconName?.replaceAll('.png', '')?.replaceAll('-', '')}' class='img-circle img-size-16' />`;
                response.result += `                </div>`;

                response.result += `                <div class='product-info'>`;
                response.result += `                    <span class='product-title ${textColor?.type}' style='font-size:13px;'>${detail?.title}`;
                //#region old code
                // response.result += `                        <span class='badge badge-light float-right' style='font-size:10px;'>`;
                // response.result += `                            ${dateTimeFormatGlobalSet(detail.created, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0).result}`;
                // response.result += `                        </span>`;
                //#endregion old code
                response.result += `                    </span>`;
                response.result += `                    <span class='product-description' style='font-size:11px;'>`;
                response.result += `                        <b>${dateTimeFormatGlobalSet({
                    date: detail?.created,
                    //type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                    type: languageObj?.format?.date?.f1,
                    format: languageObj?.format?.time?.type,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result}</b>`;
                response.result += `                    </span>`;
                response.result += `                    <span class='product-description' style='font-size:13px;'>`;
                response.result += `                        ${detail?.comment}`;
                response.result += `                    </span>`;
                response.result += `                </div>`;
                response.result += `                <a id='aib${index}' class='float-right'`;
                response.result += `                    buildingId='${buildingId}'`;
                response.result += `                    informativeBillboardId='${detail?.id}'`;
                //response.result += `                    href='${localInformativeBillboardsUrl}'`;
                response.result += `                    href='#${index}'`;
                //response.result += `                    rel='noreferrer'`;
                //response.result += `                    onClick='(e) => null'`;
                //response.result += `                    onclick='myFunction(e)'`;
                response.result += `                    style='font-size:13px'>`;
                response.result += `                    ${labels?.view?.[languageObj?.id]}`;
                //response.result += `                    ${htmlSett?.space?.formatOne}`;
                response.result += `                    <i class='${icons?.levelUp}' />`;
                //response.result += `                    <i class='${icons?.eyeIpasswordIpassword}' />`;
                response.result += `                </class=>`;
                response.result += `            </li>`;
                response.result += `        </ul>`;
                response.result += `    </div>`;

                if ((index % 2 !== 0) || ((index + 1) === informativeBillboards?.length)) {
                    response.result += `</div>`;
                }
            });
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const informativeBillboardGetAsync = async ({
        id = '',
        buildingId = '',
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'informativeBillboardGetAsync';
        let response = responseGet();
        const aElement = $(`#${e?.currentTarget?.id}`)?.[0];
        const innerHTML = aElement?.innerHTML;
        try {
            //aElement.innerHTML = `<img alt='loadingCircle' src='${globalSettings?.gifs?.normal?.circle}' height='20px' width='20px'/>`;
            aElement.innerHTML = `<span class='${htmlReact?.spinner?.borderSm}' aria-hidden='true'></span>`;

            //#region data get
            headers = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/`,
                conditionals: [
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingId, },
                ],
                ordersBy: [
                    { field: dbProps?.created, value: 'desc' },
                ],
                withDetails: true,
                id: id,
                languageId: languageObj?.id,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headers,
            );
            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                aElement.innerHTML = innerHTML;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion data get

            //#region data set
            setInformativeBillboard(response?.result?.[0]);
            //#endregion data set

            await awaitDelay({ delayTimer: timers?.threeNanoSeconds, });
            aElement.innerHTML = innerHTML;
            setInformativeBillboardShow(true);
        } catch (ex) {
            aElement.innerHTML = innerHTML;
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return response;
        }
        return response;
    }
    //#endregion nformative billboard

    //#region Loadings
    const controlsLoadingSetAsync = async ({
        _buildingQuantityShow = false,
        _apartmentQuantityShow = false,
        _apartmentBalanceShow = false,
        _buildingBalanceShow = false,
        _informativeBillboardLoadingShow = false,
        _condominiumBoardElectionShow = false,
        _apartmentsBalanceShow = false,
        _documentsShow = false,
        _suppliersBalanceShow = false,
        _collectionCashesBalanceShow = false,
        _banksBalanceShow = false,
        subMethod = '',
    }) => {
        const currentMethod = 'controlsLoadingSetAsync';
        let response = responseGet();
        try {
            setBuildingsQuantityShow(_buildingQuantityShow);
            setApartmentsQuantityShow(_apartmentQuantityShow);
            setApartmentBalanceShow(_apartmentBalanceShow);
            setBuildingBalanceShow(_buildingBalanceShow);
            setInformativeBillboardLoadingShow(_informativeBillboardLoadingShow);
            setCondominiumBoardElectionShow(_condominiumBoardElectionShow);
            setApartmentsBalanceShow(_apartmentsBalanceShow);
            setDocumentsShow(_documentsShow);
            setSuppliersBalanceShow(_suppliersBalanceShow);
            setCollectionCashesBalanceShow(_collectionCashesBalanceShow);
            setBanksBalanceShow(_banksBalanceShow);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion Loadings

    //#region others
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'Home<br/>dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let voteExecutedLocal = false;
            let collectionCachesLocal = [];
            let apartmentsBalanceLocal = [];
            let suppliersCurrentBalanceLocal = [];
            let condominiumBoardElectionDetailsLocal = [];
            //setShowData(false);
            //setShowLoading(true);
            //#endregion variables

            //#region data get
            if (auth?.isLoged()) {
                await controlsLoadingSetAsync({
                    _buildingQuantityShow: true,
                    _apartmentQuantityShow: true,
                    _apartmentBalanceShow: true,
                    _buildingBalanceShow: true,
                    _informativeBillboardLoadingShow: true,
                    _condominiumBoardElectionShow: true,
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });

                //#region dataTable set (set)
                response = dataTablesSet({
                    dtInformativeBillboard: true,
                    dtCondominiumBoardElections: true,
                    apartmentsBalance: true,
                    suppliersCurrenBalance: true,
                    collectionCaches: true,
                    queryCodeSet: true,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (set)

                //#region data get
                headers = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    }
                };

                dataObj = {
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlHome}/`,
                    conditionals: [],
                    ordersBy: [],
                    //userId: auth?.user?.uid,
                    languageId: languageObj?.id,
                    method: backend?.methods?.home?.dataByUserId,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headers,
                );
                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion data get

                //#region data set
                response = dataSet({
                    data: response?.result,
                    buildindsDataSet: true,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                voteExecutedLocal = response?.result?.voteExecuted;
                collectionCachesLocal = response?.result?.collectionCaches;
                apartmentsBalanceLocal = response?.result?.apartmentsBalance;
                suppliersCurrentBalanceLocal = response?.result?.suppliersCurrentBalance;
                condominiumBoardElectionDetailsLocal = response?.result?.condominiumBoardElectionDetails;
                //#endregion data set

                //setShowData(true);
                //setShowLoading(false);

                //#region old code
                //#region dataTable set (set)
                response = dataTablesSet({
                    dtInformativeBillboard: true,
                    dtCondominiumBoardElections: true,
                    apartmentsBalance: true,
                    suppliersCurrenBalance: true,
                    collectionCaches: true,
                    queryCodeSet: true,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (set)
                //#endregion old code

                //#region dataTable set (clear)
                response = dataTablesClear({
                    dtApartmentsBalance: true,
                    dtSuppliersBalance: true,
                    dtCollectionCashes: true,
                    dtInformativeBillboard: true,
                    dtCondominiumBoardElections: true,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (clear)

                //#region dataTable set (data)
                response = dataTablesDataSet({
                    dataApartmentsBalance: apartmentsBalanceLocal,
                    dataSuppliersBalance: suppliersCurrentBalanceLocal,
                    dataCollectionCashes: collectionCachesLocal,
                    dtCondominiumBoardElectionDetails: condominiumBoardElectionDetailsLocal,
                    executedVote: voteExecutedLocal,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    //setShowData(false);
                    //setShowLoading(false);
                    await controlsLoadingSetAsync({});
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion dataTable set (data)

                //#region Loading section
                await controlsLoadingSetAsync({
                    _buildingQuantityShow: false,
                    _apartmentQuantityShow: false,
                    _apartmentBalanceShow: false,
                    _buildingBalanceShow: false,
                    _informativeBillboardLoadingShow: true,
                    _condominiumBoardElectionShow: true,
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });

                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _apartmentsBalanceShow: true,
                    _documentsShow: true,
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _suppliersBalanceShow: true,
                    _collectionCashesBalanceShow: true,
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({
                    _banksBalanceShow: true,
                });
                await awaitDelay({ delayTimer: timers?.oneSecond, });
                await controlsLoadingSetAsync({});
                //#endregion Loading section
            }
            //#endregion data get
        } catch (ex) {
            //setShowData(false);
            //setShowLoading(false);
            await controlsLoadingSetAsync({});
            auth?.logout({
                subMethod: currentMethod,
            });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        dtInformativeBillboard = false,
        dtCondominiumBoardElections = false,
        apartmentsBalance = false,
        suppliersCurrenBalance = false,
        collectionCaches = false,
        queryCodeSet = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            //#region informative billboard
            if (dtInformativeBillboard) {
                //#region old code
                // $(`#${dtInformativeBillboardId}`)?.DataTable({
                //     autoWidth: false,
                // });
                //#endregion old code
            }
            //#endregion informative billboard

            //#region condominium board elections
            if (dtCondominiumBoardElections) {
                $(`#${dtCondominiumBoardElectionsId}`)?.DataTable({
                    autoWidth: false,
                    //buttons: ['excel', 'pdf', 'print', 'colvis',],
                    columns: [
                        { title: 'id', width: '0%', height: '0%', orderable: false, searchable: false, visible: false, },
                        {
                            title: labels?.name?.[languageObj?.id],
                            orderable: false,
                            render: function (data, type, row) {
                                let dataLocal = '';
                                dataLocal = `<span>${htmlSett?.space?.formatOne} ${data}</span>`;
                                return dataLocal;
                            },
                            width: '60%',
                        },
                        { title: labels?.floor?.[languageObj?.id], width: '10%', orderable: false, },
                        { title: labels?.apartment?.[languageObj?.id], width: '10%', orderable: false, },
                        { title: labels?.role?.[languageObj?.id], width: '10%', orderable: false, searchable: false, visible: false, },
                        { title: labels?.hierarchy?.[languageObj?.id], width: '5%', orderable: false, searchable: false, visible: false, },
                        { title: labels?.toChoose?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                    ],
                    data: [],
                    destroy: true,
                    drawCallback: function (settings) {
                        //#region variables
                        let api = this.api();
                        let rows = api.rows({ page: 'current' }).nodes();
                        let last = null;
                        //#endregion variables
                        //#region Method
                        api
                            //.column(3, { page: 'current' })
                            .column(4, { page: 'current' })
                            .data()
                            .each((groupName, index) => {
                                if (last !== groupName) {
                                    $(rows)
                                        .eq(index)
                                        .before(`<tr bgcolor="#ddd" style="font-weight:bold"><td colspan="4">${groupName}</td></tr>`);
                                    last = groupName;
                                }
                            });
                        //#endregion Method
                    },
                    //dom: '<"toolbar">frtip',
                    info: false,
                    language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                    lengthChange: false,
                    //order: [[4, 'asc'], [0, 'asc'],],
                    order: [[5, 'asc'], [1, 'asc'],],
                    responsive: true,
                    searching: false,
                    //})?.buttons()?.container()?.appendTo(`#${dtElectionApplicantsId}_wrapper .col-md-6:eq(0)`);
                });
                //$('div.toolbar').html('<b>Nikole</b>');
            }
            //#endregion condominium board elections

            //#region apartment balance
            if (apartmentsBalance) {
                $(`#${dtApartmentsBalanceId}`)?.DataTable({
                    autoWidth: false,
                    //#region old code
                    //////buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                    ////buttons: ['copy', 'excel', 'pdf', 'print',],
                    // buttons: [
                    //     { extend: 'copy', text: labels?.copy?.[languageObj?.id], },
                    //     { extend: 'excel', },
                    //     { extend: 'pdf', },
                    //     { extend: 'print', text: labels?.print?.[languageObj?.id], },
                    // ],
                    //#endregion old code
                    columns: [
                        { title: labels?.identifier?.[languageObj?.id], width: '40%', },
                        { className: 'text-right', title: labels?.floor?.[languageObj?.id], width: '15%', },
                        { className: 'text-right', title: labels?.balance?.[languageObj?.id], width: '25%', },
                    ],
                    data: [],
                    destroy: true,
                    info: false,
                    language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                    //order: [[1, 'asc'], [0, 'asc']],
                    order: [[2, 'desc'],],
                    responsive: true,
                    lengthChange: false,
                    searching: false,
                });
                //})?.buttons()?.container()?.appendTo(`#${dtApartmentsBalanceId}_wrapper .col-md-6:eq(0)`);
                //});
            }
            //#endregion apartment balance

            //#region suppliers balance
            if (suppliersCurrenBalance) {
                $(`#${dtSuppliersCurrenBalanceId}`)?.DataTable({
                    autoWidth: false,
                    //#region old code
                    // ////buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                    // //buttons: ['copy', 'excel', 'pdf', 'print',],
                    // buttons: [
                    //     { extend: 'copy', text: labels?.copy?.[languageObj?.id], },
                    //     { extend: 'excel', },
                    //     { extend: 'pdf', },
                    //     { extend: 'print', text: labels?.print?.[languageObj?.id], },
                    // ],
                    //#endregion old code
                    columns: [
                        { title: labels?.supplier?.[languageObj?.id], width: '75%', },
                        //{ title: labels?.rif?.[languageObj?.id], width: '10%', },
                        { className: 'text-right', title: labels?.balance?.[languageObj?.id], width: '25%', },
                    ],
                    data: [],
                    destroy: true,
                    info: false,
                    language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                    //order: [[1, 'asc'], [0, 'asc']],
                    //order: [[2, 'desc'],],
                    order: [[1, 'desc'],],
                    ordering: true,
                    //paging: false,
                    responsive: true,
                    lengthChange: false,
                    searching: false,
                });
                //})?.buttons()?.container()?.appendTo(`#${dtSuppliersCurrenBalanceId}_wrapper .col-md-6:eq(0)`);
                //});
            }
            //#endregion suppliers balance

            //#region collection caches
            if (collectionCaches) {
                $(`#${dtCollectionCachesId}`)?.DataTable({
                    autoWidth: false,
                    //#region old code
                    // ////buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                    // //buttons: ['copy', 'excel', 'pdf', 'print',],
                    // buttons: [
                    //     { extend: 'copy', text: labels?.copy?.[languageObj?.id], },
                    //     { extend: 'excel', },
                    //     { extend: 'pdf', },
                    //     { extend: 'print', text: labels?.print?.[languageObj?.id], },
                    // ],
                    //#endregion old code
                    columns: [
                        { title: labels?.collectionCash?.[languageObj?.id], width: '75%', },
                        //{ title: labels?.rif?.[languageObj?.id], width: '10%', },
                        { className: 'text-right', title: labels?.balance?.[languageObj?.id], width: '25%', },
                    ],
                    data: [],
                    destroy: true,
                    info: false,
                    language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                    //order: [[1, 'asc'], [0, 'asc']],
                    //order: [[2, 'desc'],],
                    order: [[1, 'desc'],],
                    ordering: true,
                    //paging: false,
                    responsive: true,
                    lengthChange: false,
                    searching: false,
                });
                //})?.buttons()?.container()?.appendTo(`#${dtCollectionCachesId}_wrapper .col-md-6:eq(0)`);
                //});
            }
            //#endregion collection caches

            //#region queryCode set (data tables)
            if (queryCodeSet) {
                response = queryCodeMetSet({ dtCondominiumBoardElection: dtCondominiumBoardElections, subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion queryCode set (data tables)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeMetSet = ({
        dtCondominiumBoardElection = false,
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeMetSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let description = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            //#endregion variables

            //#region condominium board election
            if (dtCondominiumBoardElection) {
                $(`#${dtCondominiumBoardElectionsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                    //e.preventDefault();
                    rowIndex = $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.row(this)?.index();
                    dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                    if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                        method = isUndNullEmp({ data: e?.target?.attributes?.method?.value, subMethod: currentMethod, })?.result ? '' : e?.target?.attributes?.method?.value;
                        id = isUndNullEmp({ data: e?.target?.attributes?.id?.value, subMethod: currentMethod, })?.result ? '' : e?.target?.attributes?.id?.value;
                        description = isUndNullEmp({ data: e?.target?.attributes?.description?.value, subMethod: currentMethod, })?.result ? '' : e?.target?.attributes?.description?.value;
                        if (!isUndNullEmp({ data: description, subMethod: currentMethod, })?.result) {
                            applicantsSelectedGet({ e: e, id: id, description: description, hierarchy: parseInt(method), rowIndex: dtRowIndex, subMethod: currentMethod, });
                        }
                    }
                });
            }
            //#endregion condominium board election

            //#region Event click <a></a> (global)
            //$('a.float-right').on('click', function (e) {
            $('a').on('click', async (e) => {
                //#region informative billboard
                if (!isUndNullEmp({ data: e?.currentTarget?.attributes?.informativeBillboardId?.value, subMethod: currentMethod, })?.result) {
                    e?.preventDefault();
                    await informativeBillboardGetAsync({
                        id: e?.currentTarget?.attributes?.informativeBillboardId?.value,
                        buildingId: e?.currentTarget?.attributes?.buildingId?.value,
                        e: e,
                        subMethod: e?.currentTarget?.id,
                    });
                }
                //#endregion informative billboard
            });
            //#endregion Event click <a></a> (global)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesDataSet = ({
        dataApartmentsBalance = [],
        dataSuppliersBalance = [],
        dataCollectionCashes = [],
        dtCondominiumBoardElectionDetails = [],
        executedVote = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesDataSet';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            //#endregion variables

            //#region Dt condominium board election (details)
            if (!isUndNullEmp({ data: dtCondominiumBoardElectionDetails, subMethod: currentMethod, })?.result && dtCondominiumBoardElectionDetails?.length > 0) {
                dtRows = [];
                dtCondominiumBoardElectionDetails?.forEach((detail) => {
                    dtRows.push([
                        detail.id,
                        `${detail?.apartmentUser?.user?.firstName} ${detail?.apartmentUser?.user?.lastName}`,
                        detail?.apartmentUser?.apartment?.floor,
                        detail?.apartmentUser?.apartment?.identifier,
                        detail?.condominiumBoardRole?.description,
                        detail?.condominiumBoardRole?.hierarchy,
                        checkBoxApplicantsGet({
                            condominiumBoardRoleDescription: detail?.condominiumBoardRole?.description,
                            hierarchy: detail?.hierarchy,
                            id: detail?.id,
                            selected: detail?.votes?.[0]?.selected,
                            executedVote: executedVote,
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });

                $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            }
            //#endregion Dt condominium board election (details)

            //#region Dt Supplier curretn balance
            dtRows = [];
            if (!isUndNullEmp({ data: dataApartmentsBalance, subMethod: currentMethod, })?.result && dataApartmentsBalance?.length > 0) {
                dataApartmentsBalance?.forEach((detail) => {
                    dtRows.push([
                        detail.identifier,
                        detail.floor,
                        separatorsNumbersSet({
                            number: numberSet({ number: detail?.balance, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });
            }

            $(`#${dtApartmentsBalanceId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion Dt Supplier curretn balance

            //#region Dt Supplier curretn balance
            dtRows = [];
            if (!isUndNullEmp({ data: dataSuppliersBalance, subMethod: currentMethod, })?.result && dataSuppliersBalance?.length > 0) {
                dataSuppliersBalance?.forEach((detail) => {
                    dtRows.push([
                        detail?.supplier?.description,
                        separatorsNumbersSet({
                            number: numberSet({ number: detail?.balance, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });
            }

            $(`#${dtSuppliersCurrenBalanceId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion Dt Supplier curretn balance

            //#region Dt Collection cashes
            dtRows = [];
            if (!isUndNullEmp({ data: dataCollectionCashes, subMethod: currentMethod, })?.result && dataCollectionCashes?.length > 0) {
                dataCollectionCashes?.forEach((detail) => {
                    dtRows.push([
                        detail.description,
                        separatorsNumbersSet({
                            number: numberSet({ number: detail?.currentBalance, type: 'i', languageId: languageObj?.id, subMethod: currentMethod, })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });
            }

            $(`#${dtCollectionCachesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion Dt Collection cashes
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const statusColorSet = ({
        statusId = -1,
        subMethod = '',
    }) => {
        const currentMethod = 'statusColorSet';
        let response = responseGet();
        try {
            const labelObj = $(`#${labelStatusId}`);
            switch (statusId) {
                case 0:
                    labelObj?.attr('class', 'form-label bg-primary');
                    response.result = 'form-label bg-primary';
                    break;
                case 1:
                    labelObj?.attr('class', 'form-label bg-success');
                    response.result = 'form-label bg-success';
                    break;
                case 2:
                    labelObj?.attr('class', 'form-label bg-warning');
                    response.result = 'form-label bg-warning';
                    break;
                case 3:
                    labelObj?.attr('class', 'form-label bg-info');
                    response.result = 'form-label bg-info';
                    break;
                default:
                    labelObj?.attr('class', 'form-label');
                    response.result = 'form-label';
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = 'form-label bg-danger';
            console?.error(response);
        }
        return response;
    }

    const dataTablesClear = ({
        dtApartmentsBalance = false,
        dtSuppliersBalance = false,
        dtCollectionCashes = false,
        dtInformativeBillboard = false,
        dtCondominiumBoardElections = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClear';
        let response = responseGet();
        try {
            if (dtApartmentsBalance) {
                $(`#${dtApartmentsBalanceId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            if (dtSuppliersBalance) {
                $(`#${dtSuppliersCurrenBalanceId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            if (dtCollectionCashes) {
                $(`#${dtCollectionCachesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }

            //#region old code
            // if (dtInformativeBillboard) {
            //     $(`#${dtInformativeBillboardId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            // }
            //#endregion old code

            if (dtCondominiumBoardElections) {
                $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const documentsDataGet = ({
        data = {},
        index = -1,
        subMethod = '',
    }) => {
        const currentMethod = 'documentsDataGet';
        let response = responseGet();
        response.result = {
            div: '',
            h: '',
            p: '',
            html: '',
        }
        try {
            switch (index) {
                case 0:
                    response.result.div = 'callout callout-info';
                    break;
                case 1:
                    response.result.div = 'callout callout-warning';
                    break;
                case 2:
                    response.result.div = 'callout callout-success';
                    break;
                default:
                    response.result.div = 'callout callout-warning';
                    break;
            }

            response.result.h = data?.title;
            response.result.p = data?.description?.slice(0, 55); //truncate(data?.description, { length: 55, });

            response.result.html = `<div key='${index}' class='${response?.result?.div}'>`;
            response.result.html += `<h6 class='text-info'><b>${response?.result?.h}</b></h6>`;
            response.result.html += `<p>${response?.result?.p}<br/>`;
            response.result.html += `${labels?.files?.[languageObj?.id]}: <b>${data?.files?.length}</b></p>`;
            response.result.html += `</div>`;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const bankDataGet = ({
        data = {},
        index = {},
        subMethod = '',
    }) => {
        let response = responseGet();
        response.result = {
            balance: '',
            description: '',
            label: '',
            spanBalance: '',
            html: '',
        }
        try {
            switch (index) {
                case 0:
                    response.result.spanBalance = 'badge badge-warning float-right';
                    break;
                case 1:
                    response.result.spanBalance = 'badge badge-info float-right';
                    break;
                case 2:
                    response.result.spanBalance = 'badge badge-success float-right';
                    break;
                default:
                    response.result.spanBalance = 'badge badge-warning float-right';
                    break;
            }
            response.result.label = data?.bank?.description;
            response.result.balance = separatorsNumbersSet({
                number: numberSet({ number: data?.currentBalance, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            //response.result.description = `${labels?.accounts?.[languageObj?.id]}: <b>${data?.bankAccounts}</b> / ${labels?.currentBalance?.[languageObj?.id]?.toLowerCase()}`;
            response.result.description = `${labels?.accounts?.[languageObj?.id]}: <b>${data?.bankAccounts}</b>`;

            response.result.html = `<li key='${index}' class='item'>`;
            response.result.html += `<label class='product-title text-primary'><b>${response?.result?.label}</b></label>`;
            response.result.html += `<span class='${response?.result?.spanBalance}'>${response?.result?.balance}</span>`;
            response.result.html += `<span class='product-description'>${response?.result?.description}</span>`;
            response.result.html += `</li>`;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const dataSet = ({
        data = {},
        buildindsDataSet = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataSet';
        let response = responseGet();
        try {
            //#region variables
            let banksLocal = [];
            let banksTakeLocal = [];
            let documentsLocal = [];
            let bankAccountsLocal = [];
            let voteExecutedLocal = false;
            let apartmentsBalanceLocal = [];
            let collectionCachesTakeLocal = [];
            let suppliersCurrentBalanceLocal = [];
            let condominiumBoardElectionLocal = {};
            let condominiumBoardElectionDetailsLocal = [];
            let voteExecutedDateLocal = new Date()?.toISOString();
            let collectionCachesLocal = [collectionCashModelGet({})];
            let informativeBillboardsLocal = [informativeBillboardModelGet({})];
            let buildingBalanceLocal = numberSet({ number: neutralValue, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
            let apartmentBalanceLocal = numberSet({ number: neutralValue, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
            //#endregion variables

            //#region data set
            //#region apartment / apartments
            setApartments(data?.apartments);
            setApartmentsQuantity(data?.apartmentsQuantity);
            apartmentBalanceLocal = numberSet({ number: data?.apartmentBalance, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
            setApartmentBalance(apartmentBalanceLocal);
            setApartmentBalanceFormat(separatorsNumbersSet({ number: apartmentBalanceLocal, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
            apartmentsBalanceLocal = data?.apartmentsBalance;
            setApartmentsBalance(apartmentsBalanceLocal);
            //#endregion apartment / apartments

            //#region buildings / building
            if (buildindsDataSet) {
                setBuildings(data?.buildings);
                setBuildingsQuantity(data?.buildingsQuantity);
                setBuildingDescription(data?.buildings?.[0]?.description);
            }
            buildingBalanceLocal = numberSet({ number: data?.buildingBalance, type: 'd', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
            setBuildingBalance(buildingBalanceLocal);
            setBuildingBalanceFormat(separatorsNumbersSet({ number: buildingBalanceLocal, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result);
            //#endregion buildings / building

            //#region suppliers (balance)
            suppliersCurrentBalanceLocal = data?.suppliersCurrentBalance;
            setSuppliersCurrentBalance(suppliersCurrentBalanceLocal);
            //#endregion suppliers (balance)

            //#region documents
            documentsLocal = data?.documents;
            setDocuments(documentsLocal);
            setDocumentsTake(documentsLocal?.slice(0, 3)); //take(documentsLocal, 3));
            //#endregion documents

            //#region collection caches
            collectionCachesLocal = data?.collectionCaches || [];
            //collectionCachesLocal?.sort((a, b) => a?.[dbProps?.currentBalance] < b?.[dbProps?.currentBalance] ? 1 : -1);
            setCollectionCashes(collectionCachesLocal);
            collectionCachesTakeLocal = collectionCachesLocal?.slice(0, 4);//take(collectionCachesLocal, 3);
            collectionCachesTakeLocal?.sort((a, b) => a?.[dbProps?.currentBalance] < b?.[dbProps?.currentBalance] ? 1 : -1);
            setCollectionCashesTake(collectionCachesTakeLocal);
            //#endregion collection caches

            //#region bank / bank accounts
            banksLocal = data?.banks;
            //banksLocal?.sort((a, b) => a?.[dbProps?.currentBalance] < b?.[dbProps?.currentBalance] ? 1 : -1)
            setBanks(banksLocal);
            banksTakeLocal = banksLocal?.slice(0, 3); //take(banksLocal, 3);
            banksTakeLocal?.sort((a, b) => a?.[dbProps?.currentBalance] < b?.[dbProps?.currentBalance] ? 1 : -1)
            setBanksTake(banksTakeLocal);
            bankAccountsLocal = data?.bankAccounts;
            setBankAccounts(bankAccountsLocal);
            //#endregion bank / bank accounts

            //#region condominium Board Election
            condominiumBoardElectionLocal = data?.condominiumBoardElection;
            setCondominiumBoardElection(condominiumBoardElectionLocal);
            voteExecutedLocal = !isUndNullEmp({ data: condominiumBoardElectionLocal?.executedVote, subMethod: currentMethod, })?.result ? condominiumBoardElectionLocal?.executedVote : false;
            voteExecutedDateLocal = !isUndNullEmp({ data: condominiumBoardElectionLocal?.executedVoteDate, subMethod: currentMethod, })?.result ? condominiumBoardElectionLocal?.executedVoteDate : new Date()?.toISOString();
            setExecutedVote({ executed: voteExecutedLocal, date: voteExecutedDateLocal, });
            condominiumBoardElectionDetailsLocal = data?.condominiumBoardElectionDetails;

            setCondominiumBoardElectionDetails(condominiumBoardElectionDetailsLocal);

            if (!isUndNullEmp({ data: condominiumBoardElectionLocal?.status, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: statusList, subMethod: currentMethod, })?.result && statusList?.length > 0) {
                setCondominiumBoardElectionStatus(statusList?.filter(({ id, }) => id === condominiumBoardElectionLocal?.status)?.[0] || { id: 0, description: 'udefinded' });
            }
            //#endregion condominium Board Election

            //#region informative billboards
            informativeBillboardsLocal = data?.informativeBillboards;
            setInformativeBillboards(informativeBillboardsLocal);
            //#endregion informative billboards

            //#region Nothing
            nothingLocal = {
                response, apartmentBalance, apartmentsBalance, banks, bankAccounts, buildingBalance, collectionCaches, documents, suppliersBalance: suppliersCurrentBalance, condominiumBoardElection,
                condominiumBoardElectionDetails,
            };
            //#endregion Nothing
            //#endregion data set

            //#region final data set
            response.result = {
                voteExecuted: voteExecutedLocal,
                apartmentsBalance: apartmentsBalanceLocal,
                collectionCaches: collectionCachesTakeLocal,
                suppliersCurrentBalance: suppliersCurrentBalanceLocal,
                condominiumBoardElectionDetails: condominiumBoardElectionDetailsLocal,
            }
            //#endregion final data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.condominiumBoardElectionPreviousResults?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.condominiumBoardElectionPreviousResults?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.condominiumBoardElectionPreviousResults?.id}`)?.removeClass();

                    $(`#${controls?.icons?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(controls?.icons?.condominiumBoardElectionPreviousResults.className);
                    $(`#${controls?.buttons?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(controls?.buttons?.condominiumBoardElectionPreviousResults?.className);
                    $(`#${controls?.spinners?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(controls?.spinners?.condominiumBoardElectionPreviousResults.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(`${htmlReact?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.buttons?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(htmlReact?.button?.classes?.disabled);
                    $(`#${controls?.icons?.condominiumBoardElectionPreviousResults?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(`${htmlReact?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            if (processType !== 0) {
                $(`#${controls?.buttons?.condominiumBoardElectionPreviousResults?.id}`)?.addClass(`${htmlReact?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response);
        }
        return response;
    }

    //#region old code
    // //#region Event click <a></a> (global)
    // //$('a.float-right').on('click', function (e) {
    // $('a').on('click', async function (e) {
    //     try {
    //         if (!isUndefined(e) && !isUndefined(e.currentTarget) && !isNull(e.currentTarget) && !isUndefined(e.currentTarget.attributes) &&
    //             !isUndefined(e.currentTarget.attributes.informativeBillboardId) && !isNull(e.currentTarget.attributes.informativeBillboardId.value) &&
    //             !isEmpty(e.currentTarget.attributes.informativeBillboardId.value)) {
    //             e.preventDefault();
    //             await informativeBillboardGetAsync(e.currentTarget.attributes.informativeBillboardId.value);
    //         }
    //     } catch (ex) {
    //         e.preventDefault();
    //         alert(ex?.message);
    //         console.log(e.target);
    //         console.log(e.currentTarget);
    //     }
    // });
    // //#endregion Event click <a></a> (global)
    //#endregion old code

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={'home'} />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.home?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/* <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li> */}
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.home?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged() ?
                            <div>
                                <div className='row'>
                                    <div className='col-lg-3 col-6'>
                                        <div className='small-box bg-info shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!buildingsQuantityShow}
                                                languageId={languageObj?.id} />
                                            <div className='inner'>
                                                {/* <h4>{labels?.buildings?.[languageObj?.id]}: {buildings.length}</h4> */}
                                                <h4>{buildingsQuantity}</h4>
                                                <div>
                                                    {!isUndNullEmp({ data: buildings, subMethod: currentMethod, })?.result && buildings?.length > 1 ?
                                                        <div className='form-horizontal'>
                                                            <div className='form-group row'>
                                                                <label className='col-sm-4 form-label'>
                                                                    {labels?.building?.[languageObj?.id]}:
                                                                </label>
                                                                <div className='col-sm-8'>
                                                                    <select id={controls?.selects?.buildings?.id}
                                                                        className={controls?.selects?.buildings?.className}
                                                                        defaultValue={buildings?.[0]?.id}
                                                                        onChange={(e) => buildingDataGetAsync({ e: e, subMethod: e?.currentTarget?.id, })}
                                                                        placeholder={labels?.selectBuilding?.[languageObj?.id]}
                                                                        style={{ cursor: 'pointer', }}
                                                                        title={labels?.selectBuilding?.[languageObj?.id]}>
                                                                        {buildings?.map((detail) => (
                                                                            <option key={detail?.id} value={detail?.id}>{detail?.description}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <>
                                                            {labels?.building?.[languageObj?.id]}: <b>{buildings?.length > 0 ? buildings?.[0].description : ''}</b>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className='icon'>
                                                <i className={icons?.building} />
                                            </div>
                                            <a href={backend?.urlBuildings} className='small-box-footer'>{labels?.myBuildings?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                        </div>
                                    </div>

                                    <div className='col-lg-3 col-6'>
                                        <div className='small-box bg-success shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!apartmentsQuantityShow}
                                                languageId={languageObj?.id} />
                                            <div className='inner'>
                                                {/* <h4>53<sup style={{ fontSize: 20 }}>%</sup></h4> */}
                                                <h4>{apartmentsQuantity}</h4>
                                                {/* <p>Bounce Rate</p> */}
                                                <p>{labels?.apartment?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: apartments, subMethod: currentMethod, })?.result && apartments?.length > 0 ? apartments?.[0]?.identifier : ''}</b></p>
                                            </div>
                                            <div className='icon'>
                                                <i className={icons?.houseUser} />
                                            </div>
                                            <a href={backend?.urlApartments} className='small-box-footer'>{labels?.myApartments?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                        </div>
                                    </div>

                                    <div className='col-lg-3 col-6'>
                                        <div className='small-box bg-warning shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!apartmentBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='inner'>
                                                <h4>{apartmentBalanceFormat}</h4>
                                                <p>{labels?.currentBalance?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: apartments, subMethod: currentMethod, })?.result && apartments?.length > 0 ? apartments?.[0]?.identifier : ''}</b></p>
                                            </div>
                                            <div className='icon'>
                                                <i className={icons?.handHoldingUsd} />
                                            </div>
                                            <a href={backend?.urlApartmentReceipts} className='small-box-footer'>{labels?.debtApartments?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                        </div>
                                    </div>

                                    <div className='col-lg-3 col-6'>
                                        <div className='small-box bg-danger shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!buildingBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='inner'>
                                                <h4>{buildingBalanceFormat}</h4>
                                                {/* <p>{labels?.currentBalance?.[languageObj?.id]}: <b>{!isUndefined(buildings) && buildings.length > 0 ? buildings[0].description : ''}</b></p> */}
                                                <p>{labels?.currentBalance?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: buildingDescription, subMethod: currentMethod, })?.result ?
                                                    buildingDescription : ''}</b>
                                                </p>
                                            </div>
                                            <div className='icon'>
                                                <i className={icons?.dollarSign} />
                                            </div>
                                            <a href={backend?.urlApartmentReceipts} className='small-box-footer'>{labels?.buildingDebt?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                        </div>
                                    </div>
                                </div>

                                {/* {!showLoadingByBuilding ?
                                    <> */}
                                {/* {showDataByBuilding ?
                                            <> */}
                                <div className='row'>
                                    <section className='col-lg-6 connectedSortable ui-sortable'>
                                        {/*Informative billboard*/}
                                        <div className='card card-outline card-default shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!informativeBillboardLoadingShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.informativeBillboard?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.informativeBillboard}></img> - {labels?.informativeBillboard?.[languageObj?.id]}
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                {!isUndNullEmp({ data: informativeBillboards, subMethod: 'card-body', })?.result && informativeBillboards?.length > 0 ?
                                                    htmlParser(informativeBillboardHtmlDataGet({ informativeBillboards: informativeBillboards, subMethod: 'card-body', })?.result)
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            <div className='card-footer'>
                                                <div className='row text-right'>
                                                    <a href={backend?.urlInformativeBillboards}>{labels?.seeBillboard?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    <section className='col-lg-6 connectedSortable ui-sortable'>
                                        {/*Condominium board elections*/}
                                        <div className='card card-outline card-secondary shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!condominiumBoardElectionShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.condominiumBoardElections?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.ballotBox}></img> - {labels?.condominiumBoardElections?.[languageObj?.id]}
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            {!isUndNullEmp({ data: condominiumBoardElection?.id, subMethod: currentMethod, })?.result &&
                                                !isUndNullEmp({ data: condominiumBoardElectionDetails, subMethod: currentMethod, })?.result && condominiumBoardElectionDetails?.length > 0 ?
                                                <>
                                                    <div className='card-body'>
                                                        {/*Head*/}
                                                        <div className='row text-muted'>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.description?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-9'>
                                                                {condominiumBoardElection?.description}
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.from?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                {
                                                                    dateTimeFormatGlobalSet({
                                                                        date: condominiumBoardElection?.startDate,
                                                                        //type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                                        type: languageObj?.format?.date?.f1,
                                                                        format: 0,
                                                                        addTime: false,
                                                                        languageId: languageObj?.id,
                                                                        subMethod: currentMethod,
                                                                    })?.result
                                                                }
                                                            </div>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.to?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                {
                                                                    dateTimeFormatGlobalSet({
                                                                        date: condominiumBoardElection?.endDate,
                                                                        //type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                                        type: languageObj?.format?.date?.f1,
                                                                        format: 0,
                                                                        addTime: false,
                                                                        languageId: languageObj?.id,
                                                                        subMethod: currentMethod,
                                                                    })?.result
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.status?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                <label id={labelStatusId}
                                                                    className={statusColorSet({
                                                                        statusId: !isUndNullEmp({ data: condominiumBoardElection?.status, subMethod: currentMethod })?.result ?
                                                                            condominiumBoardElection?.status : -1,
                                                                        subMethod: '',
                                                                    })?.result}>
                                                                    {HtmlParser(`${htmlSett?.space?.formatOne}${condominiumBoardElectionStatus?.description}${htmlSett?.space?.formatOne}`)}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.voteTwo?.[languageObj?.id]}</b>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                {executedVote?.executed ?
                                                                    <div>
                                                                        <i className={icons?.award}></i>
                                                                        {HtmlParser(htmlSett?.space?.formatOne)}{messages?.executed?.[languageObj?.id]}
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <i className={icons?.fileAltFar}></i>
                                                                        {HtmlParser(htmlSett?.space?.formatOne)}{messages?.NotExecuted?.[languageObj?.id]}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col-md-6'>
                                                                {executedVote?.executed ?
                                                                    <div>
                                                                        <i className={icons?.calendarAlt}></i>
                                                                        {htmlParser(htmlSett?.space?.formatOne)}
                                                                        {/* {dateTimeFormatGlobalSet(condominiumBoardElectionDetails[0].votes[0].date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 12, false).result} */}
                                                                        {
                                                                            dateTimeFormatGlobalSet({
                                                                                date: executedVote?.date,
                                                                                //type: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
                                                                                type: languageObj?.format?.date?.f1,
                                                                                format: languageObj?.format?.time?.type,
                                                                                addTime: false,
                                                                                languageId: languageObj?.id,
                                                                                subMethod: currentMethod,
                                                                            })?.result
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div></div>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-12'>
                                                                <hr />
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-3'>
                                                                <b>{labels?.remark?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-9'>
                                                                {HtmlParser(condominiumBoardElection?.remark?.replaceAll('\n', '<br/>'))}
                                                            </div>
                                                        </div>

                                                        <div className='row text-muted'>
                                                            <div className='col-md-3' >
                                                                <label htmlFor={chkApplicants01Id}>{labels?.applicants?.[languageObj?.id]}:</label>
                                                            </div>
                                                            <div className='col-md-3'>
                                                                <div className='form-group clearfix'>
                                                                    <div className='custom-control custom-switch'
                                                                        style={{ cursor: 'pointer' }}>
                                                                        <input className='custom-control-input'
                                                                            //disabled={!isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: 'custom-control custom-switch', })?.result && condominiumBoardElectionStatus?.id !== 1 ? true : false}
                                                                            disabled={isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: 'custom-control custom-switch', })?.result ? true : false}
                                                                            id={chkApplicants01Id}
                                                                            //onChange={() => !isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: 'custom-control custom-switch', })?.result && condominiumBoardElectionStatus?.id !== 1 ? null : setApplicantsHidden(!applicantsHidden)}
                                                                            onChange={() => isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: 'custom-control custom-switch', })?.result ? null : setApplicantsHidden(!applicantsHidden)}
                                                                            type='checkbox'
                                                                            style={{ cursor: 'pointer' }} />
                                                                        <label className='custom-control-label'
                                                                            htmlFor={chkApplicants01Id}
                                                                            style={{ cursor: 'pointer' }}>{applicantsHidden ? labels?.show?.[languageObj?.id] : labels?.hide?.[languageObj?.id]}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <hr />
                                                            </div>
                                                        </div>

                                                        {/*Table*/}
                                                        <div className='row'>
                                                            <div className='col-md-12'>
                                                                {!showApplicantsLoading ?
                                                                    <div className={htmlSett?.dataTables?.formats?.tableResponsiveSm} hidden={applicantsHidden}>
                                                                        <table id={dtCondominiumBoardElectionsId} className='table table-sm table-bordered' ></table>
                                                                    </div>
                                                                    :
                                                                    <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                                        width={50}
                                                                        height={50}
                                                                        color={colors?.infoColorExp}
                                                                        msgText={messages?.processing?.[languageObj?.id]}
                                                                        msgOrientation='text-center'
                                                                        msgTextMuted={true}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-footer'>
                                                        <div className='row'>
                                                            <div className='text-right'>
                                                                <div hidden={applicantsHidden || executedVote?.executed}>
                                                                    <button className='btn btn-outline-warning btn-sm mx-1'
                                                                        disabled={((!isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: 'btn btn-outline-warning btn-sm mx-1', })?.result && condominiumBoardElectionStatus?.id !== 1) || executedVote?.executed) ? true : false}
                                                                        onClick={(e) => applicantsSelectEraser({ e: e, subMethod: e?.currentTarget?.id, })}
                                                                        title={labels?.eraser?.[languageObj?.id]}
                                                                        type='button'>
                                                                        <i className={icons?.eraser}></i>
                                                                    </button>

                                                                    <button className='btn btn-outline-primary btn-sm'
                                                                        disabled={((!isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: currentMethod, })?.result && condominiumBoardElectionStatus?.id !== 1) || executedVote?.executed) ? true : false}
                                                                        onClick={(e) => condominiumBoardElectionVoteGetAsync({ e: e, subMethod: e?.currentTarget?.id, })}
                                                                        title={labels?.vote?.[languageObj?.id]}
                                                                        type='button'>
                                                                        <span hidden={!btnSaveElectionShowSpinner} className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                                                                        <i hidden={btnSaveElectionShowSpinner} className={icons?.voteYea}></i>
                                                                    </button>
                                                                </div>

                                                                <div hidden={!executedVote?.executed || applicantsHidden}>
                                                                    <button id={controls?.buttons?.condominiumBoardElectionPreviousResults?.id}
                                                                        className={controls?.buttons?.condominiumBoardElectionPreviousResults?.className}
                                                                        disabled={((!isUndNullEmp({ data: condominiumBoardElectionStatus?.id, subMethod: controls?.buttons?.condominiumBoardElectionPreviousResults?.id, })?.result && condominiumBoardElectionStatus?.id !== 1) || !executedVote?.executed)}
                                                                        onClick={(e) => condominiumBoardElectionPreviousResultsGetAsync({ e: e, id: condominiumBoardElection?.id, subMethod: e?.currentTarget?.id, })}
                                                                        title={labels?.previousResults?.[languageObj?.id]}
                                                                        type='button'>
                                                                        <i id={controls?.icons?.condominiumBoardElectionPreviousResults?.id} className={controls?.icons?.condominiumBoardElectionPreviousResults?.className} /> <span id={controls?.spinners?.condominiumBoardElectionPreviousResults?.id} className='' aria-hidden='true'></span>
                                                                    </button>
                                                                </div>

                                                                <div hidden={true}>
                                                                    <button className='btn btn-outline-secondary btn-sm mx-1'
                                                                        id={btnApplicantSelectedId}
                                                                        onClick={(e) => applicantsSelectedPost({ e: e, subMethod: e?.currentTarget?.id })}
                                                                        type='button'>
                                                                        <i className={icons?.checkCircle}></i>
                                                                    </button>
                                                                    <a id='idTestTwo' className='btn btn-outline-secondary btn-sm' href='#top' >
                                                                        <i className={icons?.chevronUp}></i>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className='card-body'></div>
                                                    <div className='card-footer'></div>
                                                </>
                                            }
                                        </div>
                                    </section>
                                </div>

                                <div className='row'>
                                    <section className='col-lg-6 connectedSortable ui-sortable'>
                                        <div className='card card-outline card-info shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!apartmentsBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.apartments?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.buildingsLogo}></img> - {labels?.apartments?.[languageObj?.id]} ({labels?.currentBalance?.[languageObj?.id]?.toLowerCase()})
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={htmlSett?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtApartmentsBalanceId} className={htmlSett?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-footer'>
                                                <div className='row text-right'>
                                                    <a href={backend?.urlApartmentReceipts}>{labels?.viewReceipts?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                                </div>

                                            </div>
                                        </div>

                                        <div className='card card-outline card-warning shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!documentsShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.document?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.documentLogo}></img> - {labels?.documents?.[languageObj?.id]} ({labels?.lastCreated?.[languageObj?.id]?.toLowerCase()}: {documentsTake?.length})
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                {!isUndNullEmp({ data: documentsTake, subMethod: currentMethod, })?.result && documentsTake?.length > 0 ?
                                                    <div>
                                                        {documentsTake?.map((data, index) =>
                                                            htmlParser(documentsDataGet({ data: data, index: index, subMethod: 'card-body', })?.result?.html)
                                                        )}
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>

                                            {/* <div className='card-body'>
                                                {documentsTake?.map((data, index) =>
                                                    htmlParser(documentsDataGet({ data: data, index: index, subMethod: 'card-body', })?.result?.html)
                                                )}
                                            </div> */}
                                            <div className='card-footer'>
                                                <div className='text-right'>
                                                    <a href={backend?.urlBuildingDocuments}>{labels?.viewDocuments?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    <section className='col-lg-6 connectedSortable ui-sortable'>
                                        <div className='card card-outline card-success shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!suppliersBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.suppliers?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.suppliersLogo}></img> - {labels?.suppliers?.[languageObj?.id]} ({labels?.currentBalance?.[languageObj?.id]?.toLowerCase()})
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={htmlSett?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtSuppliersCurrenBalanceId} className={htmlSett?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-footer text-right'>
                                                <a href={backend?.urlPurchases} >{labels?.viewPurchases?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                            </div>
                                        </div>

                                        <div className='card card-outline card-info shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!collectionCashesBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.collectionCashes?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.collectionCashLogo}></img> - {labels?.collectionCashes?.[languageObj?.id]} ({labels?.lastCreated?.[languageObj?.id]?.toLowerCase()}: {collectionCachesTake?.length})
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={htmlSett?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtCollectionCachesId} className={htmlSett?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-footer'>
                                                <div className='row text-right'>
                                                    <a href={backend?.urlCollectionCashes}>{labels?.viewCollectionCashes?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card card-outline card-warning shadow-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className={htmlReact?.overlay?.darkTextWhite}
                                                hidden={!banksBalanceShow}
                                                languageId={languageObj?.id} />
                                            <div className='card-header'>
                                                <h6 className='card-title'>
                                                    <img alt={labels?.banks?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.banksLogo}></img> - {labels?.banks?.[languageObj?.id]} ({labels?.lastCreated?.[languageObj?.id]?.toLowerCase()}: {collectionCachesTake?.length})
                                                </h6>
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='card-body p-0'>
                                                {/* <ul className='products-list product-list-in-card pl-2 pr-2'>
                                                    {banksTake?.map((data, index) => (
                                                        htmlParser(bankDataGet({ data: data, index: index, subMethod: 'card-body p-0', })?.result?.html)
                                                    ))}
                                                </ul> */}
                                                {!isUndNullEmp({ data: banksTake, subMethod: 'card-body p-0', })?.result && banksTake?.length > 0 ?
                                                    <ul className='products-list product-list-in-card pl-2 pr-2'>
                                                        {banksTake?.map((data, index) => (
                                                            htmlParser(bankDataGet({ data: data, index: index, subMethod: 'card-body p-0', })?.result?.html)
                                                        ))}
                                                    </ul> :
                                                    <></>}
                                            </div>
                                            <div className='card-footer text-right'>
                                                <div className='row text-right'>
                                                    <a href={backend?.urlBanks}>{labels?.viewBanks?.[languageObj?.id]} <i className={icons?.arrowCircleRight} /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                {/* </>
                                            :
                                            <></>
                                        } */}
                                {/* </>
                                    :
                                    <>
                                        <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                            width={40}
                                            height={40}
                                            color={colors?.infoColorExp}
                                            msgText={messages?.processing?.[languageObj?.id]}
                                            msgOrientation='text-center'
                                            msgTextMuted={true} />
                                    </>
                                } */}
                            </div>
                            :
                            <div>
                                <div className='text-center align-items-center justify-content-center'>
                                    <div className='row'>
                                        <h6 className='display-4'>
                                            {app?.name}
                                        </h6>
                                    </div>

                                    <div className='row'>
                                        <p className='lead mb-5'>
                                            {messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                        </p>
                                    </div>

                                    <div className='row'>
                                        <p>
                                            <img alt='appLogo' src={globalSettings?.images?.appLogo} style={styles?.appLogoHome} />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {informativeBillboardShow ?
                <InformativeBillboardAddEdit $={$}
                    auth={auth}
                    processValue={
                        {
                            processType: 2,
                            titleTypes: textByNumericStatus({ languageId: languageObj?.id, subMethod: currentMethod, }),
                        }
                    }
                    building={{ process: { edit: false } }}
                    informativeBillboard={informativeBillboard}
                    setInformativeBillboard={setInformativeBillboard}
                    showModal={informativeBillboardShow}
                    setShowModal={setInformativeBillboardShow}
                    informativeBillboardsGetAsync={null}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}